import React from 'react';
import { useNavigate } from 'react-router-dom';

const MIGRATION_POPUP_KEY = 'verbatim_migration_popup_shown';

const MigrationPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleResetPassword = () => {
    navigate('/mot-de-passe-oublie');
    closePopup();
  };

  const closePopup = () => {
    // Sauvegarder dans le localStorage que le popup a été vu
    localStorage.setItem(MIGRATION_POPUP_KEY, 'true');
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full border-t-4 border-primary">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold text-gray-800 flex items-center">
            <span className="mr-2">✨</span> Bienvenue sur Verbatim !
          </h3>
          <button
            onClick={closePopup}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-600 mb-4 leading-relaxed">
            Bonjour ! Nous sommes heureux de vous accueillir sur la toute nouvelle version de Verbatim. 
            L'application a été entièrement repensée pour vous offrir une meilleure expérience ! 🎉
          </p>
          <p className="text-gray-600 mb-4 leading-relaxed">
            Si vous aviez déjà un compte chez nous, pas de souci ! 
            Il vous suffit simplement de réinitialiser votre mot de passe pour retrouver toutes vos données 
            et découvrir les nouvelles fonctionnalités.
          </p>
        </div>
        
        <div className="flex justify-center">
          <button
            onClick={handleResetPassword}
            className="bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition duration-300 shadow-sm flex items-center"
          >
            <span className="mr-2">🔑</span> Réinitialiser mon mot de passe
          </button>
        </div>
      </div>
    </div>
  );
};

export default MigrationPopup; 